<template>
  <div v-html="content" :class="['static-page-content']" />
</template>
<script>
export default {
  name: 'StaticPage',
  data () {
    return {
      content: null
    }
  },
  props: {
    uri: {
      type: String,
      required: true
    }
  },
  watch: {
    $route () {
      this.getPage()
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    getPage () {
      this.$http({
        url: `${this.uri}.html`
      }).then(response => {
        const config = this.$config
        this.content = response.data
          .replace(/{{payPalDonateLink}}/gi, config.payPalDonateLink)
          .replace(/{{weMakeSitesNet}}/gi, config.weMakeSitesNet)
          .replace(/{{endPoint}}/gi, config.apiRoot)
        this.$nextTick(() => {
          document.querySelectorAll('.static-page-content a').forEach(link => {
            link.classList.add(config.colors.links)
            if (link.hasAttribute('data-route')) {
              link.onclick = (event) => {
                const path = link.getAttribute('href')
                event.preventDefault()
                if (path !== this.$route.path) {
                  this.$router.push({path})
                }
              }
            }
          })
        })
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/static-page-content.vue